import script from "./channel-index.vue?vue&type=script&setup=true&lang=js"
export * from "./channel-index.vue?vue&type=script&setup=true&lang=js"

import "./channel-index.vue?vue&type=style&index=0&id=06ff0793&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ff0793"]])

export default __exports__